import React from 'react'
import { INode } from 'shared/types/tree'
import { NavigableNodeTypes, NodeType } from 'shared/types/ingestion'
import { NavItem } from '../table_of_contents/types'
import { DndToc } from './DndToc'
import { NodeDndToc, WithParentId } from './types'

export function DndCurriculaTree({
  tree,
  onItemDrop,
  onItemSelect,
  selectedItem,
}: {
  tree: INode
  onItemSelect: (item: NavItem) => void
  selectedItem?: string
  onItemDrop: (
    droppedItem: WithParentId<NodeDndToc>,
    nextItem: WithParentId<NodeDndToc>,
  ) => void
}) {
  return (
    <DndToc
      items={treeNavItems(tree)}
      onItemSelect={onItemSelect}
      selectedItemId={selectedItem}
      onItemDrop={onItemDrop}
    />
  )
}

function isContentType(node: INode) {
  return [...NavigableNodeTypes, NodeType.Note].includes(node.type as NodeType)
}

const nodeToNavItem = ({
  id,
  title,
  type,
  tree_id: treeId,
  version,
}: INode) => ({
  id,
  title,
  subtitle: `type: ${type}`,
  children: [],
  type: 'INode',
  treeId,
  version,
})

function treeNavItems(tree: INode) {
  const doChild = (node: INode, parentNav: NavItem): boolean => {
    const navItem = nodeToNavItem(node)
    parentNav.children.push(navItem)
    node.nodes.forEach((n) => doChild(n, navItem))
    return true
  }
  const navItems = [nodeToNavItem(tree)]
  tree.nodes.forEach((child) => doChild(child, navItems[0]))
  return navItems
}
